import { render, staticRenderFns } from "./CenterSearchProduct.vue?vue&type=template&id=5ef4e4fd&"
import script from "./CenterSearchProduct.vue?vue&type=script&lang=js&"
export * from "./CenterSearchProduct.vue?vue&type=script&lang=js&"
import style0 from "./CenterSearchProduct.vue?vue&type=style&index=0&id=5ef4e4fd&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShopifyImage: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/ShopifyImage.vue').default})
